import ErrorComponent from './error-component';
import { withTranslation } from 'react-i18next';

export default withTranslation()(ErrorComponent);